import * as React from 'react';
import { SpotlightedStores as SpotlightedStores$1 } from '@grandvisionhq/common';
import { compose } from '@grandvisionhq/utils';
import '@swc/helpers';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../utils/http-client.js';
import { fromSpotlightedStoresContentToListBlock } from '../../hooks/adapters.js';
import '@grandvisionhq/state';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachPageRoutes } from '../../hooks/use-bloomreach-page-routes.js';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsSpotlightedStores = ({ content  })=>{
    const { routes  } = useBloomreachPageRoutes();
    const columns = React.useMemo(()=>{
        if (!content) {
            console.warn('no columns defined for CmsSpotlightedStores component');
            return [];
        }
        return [
            fromSpotlightedStoresContentToListBlock('firstListBlock', content === null || content === void 0 ? void 0 : content.leftColumn),
            fromSpotlightedStoresContentToListBlock('secondListBlock', content === null || content === void 0 ? void 0 : content.middleColumn),
            fromSpotlightedStoresContentToListBlock('thirdListBlock', content === null || content === void 0 ? void 0 : content.rightColumn), 
        ]/* if a column is empty move the others closer */ .filter((column)=>{
            return column.links.length > 0 || !!(column === null || column === void 0 ? void 0 : column.title);
        });
    }, [
        content
    ]);
    if (columns.length === 0) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "site-container"
        }, /*#__PURE__*/ React.createElement("h1", null, "No columns defined for CmsSpotlightedStores component"));
    }
    return /*#__PURE__*/ React.createElement(SpotlightedStores$1, {
        items: columns,
        storesUrl: routes['store-overview']
    });
};
var SpotlightedStores = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent)(CmsSpotlightedStores);

export { CmsSpotlightedStores, SpotlightedStores as default };
//# sourceMappingURL=SpotlightedStores.js.map
